import React, { useState } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

const Container = styled.div`
  color: #162b92;
  font-weight: bold;
  font-size: small;
  `
const Text = styled.div`
  padding-inline: 1.5em;
  margin-bottom: 1.5em;
`
const TRed = styled.span`
  color: #C00000;
`

const FormExtrangero = ({isActive}) => {

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  return(
    (isActive) &&
      <Container>
        <Text><TRed>Número de DNI no encontrado 2.</TRed></Text>
        <Text>Ingresa tu <TRed>correo</TRed> para enviarte un <TRed>código de registro.</TRed></Text>
        <div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Row>
              <Form.Group controlId="validationEmail">
                <Form.Control className="input-lineal" type="email" placeholder="Ingrese un correo electrónico" required/>
                <Form.Control.Feedback type="invalid">Por favor ingrese un email válido.</Form.Control.Feedback>
                <Form.Control.Feedback type="valid">Email válido.</Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <button className="btn btn-primary"type="submit">Enviar código</button>
          </Form>

        </div>
      </Container>
  )
}

export default FormExtrangero;